import { Box, Typography } from "@mui/material"

const SectionHeaderImageIcon = ({ icon, sectionTitle }) =>
  <Box
    display='flex'
    alignItems='center'
    width='80vw'
    sx={{ mt: 5 }}
  >
    <Box
      component='img'
      src={icon}
      alt="Logo"
      sx={{ maxWidth: 40, mb: 2, ml: 1 }}

    />
    <Typography
      variant='title_bold'
      sx={{ p: 1, fontSize: "1rem" }}
    >
      {sectionTitle}
    </Typography>
  </Box>

export default SectionHeaderImageIcon